import { CompetitionType } from '../../types/domain.types';
import { api } from '../api-client.config';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

const updateCompetition = (competition: CompetitionType) =>
  api.put(`/competitions/${competition.competition_id}`, competition);

export const useUpdateCompetitionMutation = () => {
  return useMutation({
    mutationFn: updateCompetition,
    mutationKey: ['competitions'],
    onSuccess: () => {
      toast.success('Competition updated successfully');
    },
    onError: (error) => {
      Promise.reject(error);
    },
  });
};
